import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import Engardio from "../../../../content/people/joel-engardio/engardio.js";
import * as React from 'react';
export default {
  ElectedInfo,
  Engardio,
  React
};